var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 27.5002C29.0875 27.5002 34.8332 21.7545 34.8332 14.6668C34.8332 7.57918 29.0875 1.8335 21.9998 1.8335C14.9122 1.8335 9.1665 7.57918 9.1665 14.6668C9.1665 21.7545 14.9122 27.5002 21.9998 27.5002Z",
    stroke: "#3d3d5c",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0518 25.4651L12.8335 42.1668L22.0002 36.6668L31.1668 42.1668L28.9485 25.4468",
    stroke: "#3d3d5c",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.0c5ff4a66e0ba898b26c90da2fa289e4.svg";
export { ForwardRef as ReactComponent };